import { Box, List, ListItem } from "@mui/material";
import React from "react";
import styles from "../../styles/pages/home.module.scss";
// import assest from '@/json/assest';
import assest from "../../json/assest";
import LongArrowNew from "../../ui/Icons/LongArrowNew";

// import Image from 'next/image';
// export type TableModalHeaderProps = {
//   fromStatus?:string;
//   toStatus?:string;
//   title?:string
// }
export default function TableModalHeader(props) {
  const { title, fromStatus, toStatus } = props;
  // console.warn('fromStatus', fromStatus)
  return (
    <>
      <Box className={styles.dashboard_confirm_left}>
        <p>{title || "Confirmed Videos"}</p>
      </Box>
      <Box className={styles.dashboard_confirm_right}>
        <List>
          <ListItem> {fromStatus || "Approved"} </ListItem>
          <ListItem className={styles.dashboard_confirm_arw}>
            {" "}
            {/* <img
              src={assest.arrow_long_htm}
              width={54}
              height={10}
              alt=""
            /> */}
            <i className={styles.arrow_ic}>
              <LongArrowNew />
            </i>{" "}
          </ListItem>
          <ListItem> {toStatus || "Approved"} </ListItem>
        </List>
      </Box>
    </>
  );
}
